import clsx from 'clsx';
import styles from './Mono.module.css';

/**
 * Tank Redesign Mono atom — inline monospace span.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Mono` function.
 * Used for IDs, timestamps, file paths, and other technical text inline.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export default function Mono({ className, children, ...rest }) {
  return (
    <span className={clsx(styles.mono, className)} {...rest}>
      {children}
    </span>
  );
}
